import {outter_post_newUrl, outter_post,post} from 'common/js/axios-helper';
import {FinanceApi,PospApi} from "./constant/UrlMapper";

const host = '8885';
const host2 = '8883';
const host3 = '8880';
const host4 = '8889';
// 商户管理列表
const PospApLiist = (data) => {
    return post(PospApi.PospApLiist, data, host2);
};
// 商户管理通道商户列表
const channelMerchant = (data) => {
    console.log(data,'data')
    return post(PospApi.channelMerchant + '?merNo=' + data.merCode ,data, host2);
};
// 商户管理列表
const merTidInfoList = (data) => {
    return post(PospApi.merTidInfoList, data, host2);
};
// 商户子页面管理列表
const merAcqTidCnvList = (data) => {
    return post(PospApi.merAcqTidCnvList, data, host2);
};
const getadjusts = (data) => {
    return outter_post(FinanceApi.GetAdjusts, data, host);
};


const getTatAssets = (data) => {
    return outter_post(FinanceApi.GetTatAssets, data, host);
};

const adjust = (data) => {
    return outter_post(FinanceApi.Adjust, data, host);
};

const getOutComeDtl = (data) => {
    return outter_post(FinanceApi.GetOutComeDtl, data, host);
};

const getAdminAccDtl = (data) => {
    return outter_post(FinanceApi.GetAdminAccDtl, data, host);
};
const getMoney = (data) => {
    return outter_post(FinanceApi.GetMoney, data, host);
};

const receivedetailTiaoz = (data) => {
    return outter_post(FinanceApi.ReceivedetailTiaoz, data, host);
};

const getTatAccDtl = (data) => {
    return outter_post(FinanceApi.GetTatAccDtl, data, host);
};

const getTatAccDtlNew = (data) => {
    return outter_post_newUrl(FinanceApi.GetTatAccDtl, data, host4);
};

const selectFinTatacctDtl = (data) => {
    return outter_post(FinanceApi.SelectFinTatacctDtl, data, '8892');
};

const getMemAccDtl = (data) => {
    return outter_post(FinanceApi.GetMemAccDtl, data, host);
};

const getMemAccDtlNew = (data) => {
    return outter_post_newUrl(FinanceApi.GetMemAccDtl, data, host4);
};

const getMemRewardAccDtl = (data) => {
    return outter_post(FinanceApi.GetMemRewardAccDtl, data, host);
};

const getMemRewardAccDtlNew = (data) => {
    return outter_post_newUrl(FinanceApi.GetMemRewardAccDtl, data, host4);
};

const getRecharges = (data) => {
    return outter_post(FinanceApi.GetRecharges, data, host);
};

const saveRecharge = (data) => {
    return outter_post(FinanceApi.SaveRecharge, data, host);
};

const getMemAccts = (data) => {
    return outter_post(FinanceApi.GetMemAccts, data, host);
};

const getMemUpDtl = (data) => {
    return outter_post(FinanceApi.GetMemUpDtl, data, host);
};

const getWithdraws = (data) => {
    return outter_post(FinanceApi.GetWithdraws, data, host);
};

const applyWithDraw = (data) => {
    return outter_post(FinanceApi.ApplyWithDraw, data, host);
};

const addTatAccountInfo = (data) => {
    return outter_post(FinanceApi.AddTatAccountInfo, data, host);
};

const getAcctInfo = (data) => {
    return outter_post(FinanceApi.GetAcctInfo, data, host);
};

const getRealNameByPhone = (data) => {
    return outter_post(FinanceApi.GetRealNameByPhone, data, host);
};

const getRealNameByPhones = (data) => {
    return outter_post(FinanceApi.GetRealNameByPhones, data, host);
};
const getNamePhoneNumber = (data) => {
    return outter_post(FinanceApi.GetNamePhoneNumber, data, host);
};
const getMerNo = (data) => {
    return outter_post(FinanceApi.GetMerNo, data, host);
};

const selectTempAcct = (data) => {
    return outter_post(FinanceApi.SelectTempAcct, data, host2);
};

const closeTempAcct = (data) => {
    return outter_post(FinanceApi.CloseTempAcct, data, host2);
};

const dtlList = (data) => {
    return outter_post(FinanceApi.DtlList, data, host2);
};

const shareWithdrawalList = (data) => {
    return outter_post(FinanceApi.ShareWithdrawalList, data, host3);
};

const shareWithdrawalAdd = (data) => {
    return outter_post(FinanceApi.ShareWithdrawalAdd, data, host3);
};

const shareWithdrawalBalanceQuery = (data) => {
    return outter_post(FinanceApi.ShareWithdrawalBalanceQuery, data, host3);
};


const tatTaxLogList = (data) => {
    return outter_post(FinanceApi.TatTaxLogList, data, host3);
};

const tatTaxMemList = (data) => {
    return outter_post(FinanceApi.TatTaxMemList, data, host3);
};

const tatTaxMemAdd = (data) => {
    return outter_post(FinanceApi.TatTaxMemAdd, data, host3);
};

const tatTaxMemStatistics = (data) => {
    return outter_post(FinanceApi.TatTaxMemStatistics, data, host3);
};

const TatTaxMemcheckOnly = (data) => {
    return outter_post(FinanceApi.TatTaxMemcheckOnly, data, host3);
};

const tatTaxMemDel = (data) => {
    return outter_post(FinanceApi.TatTaxMemDel, data, host3);
};

const tatTaxMemParameterList = (data) => {
    return outter_post(FinanceApi.TatTaxMemParameterList, data, host3);
};

const tatTaxMemParameterDel = (data) => {
    return outter_post(FinanceApi.TatTaxMemParameterDel, data, host3);
};

const tatTaxMemParameterAdd = (data) => {
    return outter_post(FinanceApi.TatTaxMemParameterAdd, data, host3);
};

const tatTaxMemParameterEdit = (data) => {
    return outter_post(FinanceApi.TatTaxMemParameterEdit, data, host3);
};

const tatTaxMemEdit = (data) => {
    return outter_post(FinanceApi.TatTaxMemEdit, data, host3);
};

const tatTaxLogAdd = (data) => {
    return outter_post(FinanceApi.TatTaxLogAdd, data, host3);
};

const frozen = (data) => {
    return outter_post(FinanceApi.Frozen, data, host);
};

const memUpSecond = (data) => {
    return outter_post(FinanceApi.MemUpSecond, data, host2);
};


const getMemAccDtlCountOperationAmt = (data) => {
    return outter_post(FinanceApi.GetMemAccDtlCountOperationAmt, data, host);
};


const getMemAccDtlCountOperationAmtNew = (data) => {
    return outter_post_newUrl(FinanceApi.GetMemAccDtlCountOperationAmt, data, host4);
};

const sumTatAccDtl = (data) => {
    return outter_post(FinanceApi.SumTatAccDtl, data, host);
};
const sumMemAccDtl = (data) => {
    return outter_post(FinanceApi.SumMemAccDtl, data, host);
};

const sumTatAccDtlNew = (data) => {
    return outter_post_newUrl(FinanceApi.SumTatAccDtl, data, host4);
};

const tatTaxList = (data) => {
    return outter_post(FinanceApi.TatTaxList, data, host3);
};

const tatTaxAdd = (data) => {
    return outter_post(FinanceApi.TatTaxAdd, data, host3);
};

const tatTaxEdit = (data) => {
    return outter_post(FinanceApi.TatTaxEdit, data, host3);
};

const tatTaxLog = (data) => {
    return outter_post(FinanceApi.TatTaxLog, data, host3);
};

const checkOnly = (data) => {
    return outter_post(FinanceApi.CheckOnly, data, host3);
};

const tatGeneralizationDtlList = (data) => {
    return outter_post(FinanceApi.TatGeneralizationDtlList, data, host3);
};

const tatGeneralizationDtlAwardSum = (data) => {
    return outter_post(FinanceApi.TatGeneralizationDtlAwardSum, data, host3);
};


//分红计划
const bonusplanList = (data) => {
    return outter_post(FinanceApi.BonusPlanList, data, host);
};
const bonusplanSh = (data) => {
    return outter_post(FinanceApi.BonusPlanSh, data, host);
};
const bonusplanPlSh = (data) => {
    return outter_post(FinanceApi.BonusPlanPlSh, data, host);
};
const bonusplanEdit = (data) => {
    return outter_post(FinanceApi.BonusPlanEdit, data, host);
};
const bonusplanFhjs = (data) => {
    return outter_post(FinanceApi.BonusPlanFhjs, data, host);
};
const bonusplanHj = (data) => {
    return outter_post(FinanceApi.BonusPlanHj, data, host);
};
const bonusplanDel = (data) => {
    return outter_post(FinanceApi.BonusPlanDel, data, host);
};

const busitype = (data) => {
    return outter_post(FinanceApi.BusiType, data, host);
};


//转账审核
const transferaccountsshList = (data) => {
    return outter_post(FinanceApi.TransferAccountsShList, data, host);
};
const transferaccountsshSh = (data) => {
    return outter_post(FinanceApi.TransferAccountsShSh, data, host);
};

export default {
    receivedetailTiaoz,
    channelMerchant,
    busitype,
    PospApLiist,
    merTidInfoList,
    merAcqTidCnvList,
    getadjusts,
    getTatAssets,
    adjust,
    getOutComeDtl,
    getAdminAccDtl,
    getMoney,
    getTatAccDtl,
    getTatAccDtlNew,
    selectFinTatacctDtl,
    getMemAccDtl,
    getMemAccDtlNew,
    getMemRewardAccDtl,
    getMemRewardAccDtlNew,
    getRecharges,
    saveRecharge,
    getMemAccts,
    getMemUpDtl,
    getWithdraws,
    applyWithDraw,
    addTatAccountInfo,
    getAcctInfo,
    getRealNameByPhone,
    getRealNameByPhones,
    getNamePhoneNumber,
    getMerNo,
    selectTempAcct,
    closeTempAcct,
    dtlList,
    shareWithdrawalList,
    shareWithdrawalAdd,
    shareWithdrawalBalanceQuery,
    tatTaxLogList,
    tatTaxMemList,
    tatTaxMemAdd,
    tatTaxMemStatistics,
    TatTaxMemcheckOnly,
    tatTaxMemDel,
    tatTaxMemParameterList,
    tatTaxMemParameterDel,
    tatTaxMemParameterAdd,
    tatTaxMemParameterEdit,
    tatTaxMemEdit,
    tatTaxLogAdd,
    frozen,
    getMemAccDtlCountOperationAmt,
    getMemAccDtlCountOperationAmtNew,
    sumTatAccDtl,
    sumTatAccDtlNew,
    sumMemAccDtl,
    tatTaxList,
    tatTaxAdd,
    tatTaxEdit,
    tatTaxLog,
    checkOnly,
    tatGeneralizationDtlList,
    tatGeneralizationDtlAwardSum,
    memUpSecond,

    bonusplanList,
    bonusplanEdit,
    bonusplanSh,
    bonusplanPlSh,
    bonusplanFhjs,
    bonusplanHj,
    bonusplanDel,

    transferaccountsshList,
    transferaccountsshSh,
}



// WEBPACK FOOTER //
// ./src/service/FinanceService.js